import { render, staticRenderFns } from "./WAITING_SAMPLE_RECOLLECT.vue?vue&type=template&id=63f65383&"
import script from "./WAITING_SAMPLE_RECOLLECT.vue?vue&type=script&lang=js&"
export * from "./WAITING_SAMPLE_RECOLLECT.vue?vue&type=script&lang=js&"
import style0 from "./WAITING_SAMPLE_RECOLLECT.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports